import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function ShopifyRedirect() {

    const navigate = useNavigate();

    useEffect(() => {

        //--------------------------------------------------
        // Read Shopify installation details
        //--------------------------------------------------

        const params = new URLSearchParams(

            window.location.search

        );

        const integrationUid = params.get(

            "integrationUid"

        );

        const shopName = params.get(

            "shopName"

        );

        const shopDomain = params.get(

            "shopDomain"

        );

        console.log('shopName: ', shopName);
        console.log('shopDomain: ', shopDomain);
        console.log('integrationUid: ', integrationUid);

        //--------------------------------------------------
        // Save Shopify installation
        //--------------------------------------------------

        localStorage.setItem(

            "shopifyInstallation",

            JSON.stringify({

                integrationUid,

                shopName,

                shopDomain,

            })

        );

        //--------------------------------------------------
        // Determine which flow the user came from
        //--------------------------------------------------

        const flow = localStorage.getItem(

            "shopifyFlow"

        );

        console.log("Flow in redirect: ", flow);

        if (flow === "onboarding") {

            navigate(

                "/setup/integrations/shopify",

                {

                    replace: true,

                }

            );

        }

        else {

            navigate(

                "/signup",

                {

                    replace: true,

                }

            );

        }

    }, [navigate]);

    return null;

}